import { type CountryCode, PhoneNumber, parsePhoneNumber, getExampleNumber, formatIncompletePhoneNumber } from 'libphonenumber-js/max'

interface PhoneOptions {
    trimLeadingZero?: boolean
}

export function usePhone(options?: PhoneOptions) {
    const phone = ref<string>()
    const countryCode = ref<string>()
    const parsedPhone = ref<PhoneNumber>()
    const isValidPhone = ref<boolean>(false)
    const isMobile = ref<boolean>(false)

    function parse(_number: string, _iso2?: string): PhoneNumber | undefined {
        const number = _number.replaceAll(' ', '')
        const hasPlusSign = number ? number.charAt(0) == '+' : false
        phone.value = number

        try {
            parsedPhone.value = hasPlusSign ? parsePhoneNumber(number) : parsePhoneNumber(number, _iso2 as CountryCode)

            isValidPhone.value = parsedPhone.value.isValid()
            isMobile.value = parsedPhone.value.getType() === 'MOBILE' || parsedPhone.value.getType() === 'FIXED_LINE_OR_MOBILE'
        } catch (e) {
            parsedPhone.value = undefined
            isValidPhone.value = false
            isMobile.value = false
        }

        if (parsedPhone.value && hasPlusSign) {
            countryCode.value = parsedPhone.value.country
        }

        return parsedPhone.value
    }

    const formattedNational = computed((): string | undefined => {
        if (!phone.value) return undefined
        if (!parsedPhone.value || !countryCode.value) return phone.value
        if (isValidPhone.value) {
            if (options?.trimLeadingZero) return parsedPhone.value.format('NATIONAL').replace(/^0+/, '')
            return parsedPhone.value.format('NATIONAL')
        }
        return formatIncompletePhoneNumber(phone.value, countryCode.value as CountryCode)
    })

    return {
        countryCode,
        isValidPhone,
        formattedNational,
        parse,
    }
}
